/**
 * Utility predicates for number mask processing.
 */

/** Returns true if the string contains one or more zeros and nothing else. */
export const isAllZeros = (str: string): boolean => /^0+$/.test(str);

/** Returns true if the string is empty or contains only zeros. */
export const isEmptyOrAllZeros = (str: string): boolean =>
  str === "" || /^0*$/.test(str);

/** Returns true if the string is a single non-zero digit (1-9). */
export const isNonZeroDigit = (str: string): boolean => /^[1-9]$/.test(str);
